import React, { useState } from "react";
import Header from "./Header";

import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";
const common = _common;

export function loginDone(data: any) {
  try {
    if (data.memberId) {
      localStorage?.setItem("user", JSON.stringify(data));

      window.location.href = "/";
    } else {
      $(".error").show();
      $("#msg1").html("Falsche Mitgliedsnummer oder PIN");
    }
  } catch (ex: any) {
    alert('Wahrscheinlich sind in den Einstellungen "Alle Cookies blockiert" +\n Um den digitalen Clubpass zu verwenden mußt Du Cookies zulassen' + ex.message);
  }
}

export default function Login() {
  const [error, setError] = useState<string | undefined>(undefined);

  async function registieren() {
    var registerInfo = {
      email: $("#memberId").val(),
      pin: $("#pin").val(),
    };
    const data = await ServerInterface.register(registerInfo);
    if (data) {
      data.email = $("#memberId").val();
      data.pin = $("#pin").val();
      loginDone(data);
    }
  }

  async function requestPinBrief(email: string) {
    const res = await ServerInterface.requestPinBrief(email);
    if (res) {
      var text = "Deine Emailadresse wurde nicht gefunden \n";
      text += "Bitte korrigiere die Emailadresse, \n";

      common.myAlert(text, "Pinbrief konnte nicht versendet werden");
    } else {
      common.myAlert("Der Zugang zur Buchnungsapp\n sollte in Kürze in Deinem Posteingang sein", "Wir haben Dir eine Email gesendet");
    }
  }

  return (
    <div id="top" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", }}>
      <div style={{ position: "absolute", top: "0px", left: "0px", width: "100%", height: "100%", backgroundColor: "#eee", zIndex: "-1" }}></div>
      <Header noAvatar={true} />
      <div style={{ padding: "10px", display: "flex", justifyContent: "center", flexGrow: "1", alignItems: "center", flexDirection: "column" }}>

        <div
          style={{
            textAlign: "left",
            backgroundColor: "#eee",
            padding: "20px",
            boxShadow: "silver 5px 5px 20px",
            borderRadius: "10px",
            overflow: "hidden",
            border: "1px solid #aaaa",
            paddingTop: "5px"
          }}
        >
          <div style={{ fontSize: "1.5em", fontWeight: "bold", textAlign: "center", margin: "10px" }}>
            Login
          </div>

          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>

            <br />
            <input id="memberId" type="text" style={{ width: "250px" }} placeholder="Email oder Mitgliedsnummer" />
            <br />

            <input id="pin" type="text" placeholder="Pin" style={{ width: "250px" }} />

            <br />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "30px", marginBottom: "30px" }}>
              <button
                style={{ whiteSpace: "nowrap" }}
                className="btn"
                onClick={(ev: any) => requestPinBrief((document.getElementById("memberId") as any)?.value)}
              >
                Pin Anfordern
              </button>
              <div style={{ width: "20px" }}></div>
              <button
                style={{ marginRight: "10px" }}
                className="btn btn-primary"
                type="button"
                onClick={() => {
                  registieren();
                }}
              >
                Login
              </button>
            </div>
          </div>


          <br />
          <div>
            <div style={{ fontSize: "0.8em", color: "#666", textAlign: "center" }} >
              Du hast Deine Pin nicht zur Hand? <br />
              Tippe auf "Pin anfordern" und wir senden sie Dir per Mail an die oben eingegebene Adresse zu <br />
            </div>
          </div>

        </div >


        <div style={{ display: "none", textAlign: "center", fontSize: "0.8em", padding: "20px" }}>
          <br />
          <br />

          <p>Zum Benutzen userer Platzreservierung musst Du Dich einmalig auf diesem Gerät anmelden</p>
          <p>
            Dadurch wird dieses Gerät für Dich personalisiert, <br />
            und Du kannst bequem Platzreservierungen vornehmen
          </p>
          <p>Dieses Gerät kann danach nicht mehr ohne weiteres für eine Reservierung durch andere (Familien-)Mitgliedern genutzt werden.</p>
          <p style={{ fontWeight: "bold" }}>
            Daher bietet es dringend an, <br />
            hierzu Dein Handy zu verwenden.
          </p>

          <p style={{ fontSize: "0.7em" }}>Du kannst aber mehrere Handys und Laptops gleichzeitig verwenden</p>

        </div>


        {
          error && (
            <div className="error" style={{ backgroundColor: "#ff8888", padding: "1em" }}>
              <div id="msg1" style={{ textAlign: "center", fontSize: "1em" }}>
                {error}
              </div>
            </div>
          )
        }
      </div >
    </div >
  );
}
